import {Theme} from '~shared/models/settings';

import {LIGHT_BACKGROUND_URL, DARK_BACKGROUND_URL} from './constants';

export const getBackgroundUrl = (theme: Theme) => {
    return theme === Theme.Light ? LIGHT_BACKGROUND_URL : DARK_BACKGROUND_URL;
};
